import { Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import { REDUX_STORE_SLICES } from '../../../services/exports/Constants';
import useStore from '../../../hooks/store/useStore';
import useBasket from '../../../hooks/basket/useBasket';
import Theme from '../../Theme';

export default function MarketingSubscriptionSection() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Marketing:MarketingSubscriptionConsent' });

  const { localData, update } = useOrderFlow();
  const { items } = useBasket();
  const { profile } = useStore<REDUX_STORE_SLICES.PROFILE>(REDUX_STORE_SLICES.PROFILE);

  return (
    profile &&
    !profile.is_marketing_subscriber &&
    items.length > 0 && (
      <div className="flex items-start gap-sm p-md bg-blue-200 rounded-md lg:mx-none mx-md mb-md">
        <Checkbox
          checked={localData.marketing_consent}
          onChange={(e) => update('marketing_consent', e.target.checked)}
          id="is_marketing_subscriber"
          sx={{
            color: Theme.color.blue['300'],
            '&.Mui-checked': {
              color: Theme.color.blue['300'],
            },
          }}
        />
        <div>
          <label htmlFor="is_marketing_subscriber" className="ml-2xs my-auto text-sm">
            {t('text')}
          </label>
        </div>
      </div>
    )
  );
}
